import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { FaEnvelope, FaExclamationTriangle } from "react-icons/fa";
import { axiosAdminAuthClient } from "../../api";
import { selectUser } from "../../store/slices/auth/slice";

import {
  AuthPageWrapper,
  AuthBackground,
  AuthWrapper,
  AuthContainer,
  AuthTitle,
  AuthSubtitle,
  AuthForm,
  AuthLink,
  StatusContainer,
  StatusIcon,
  StatusTitle,
  StatusMessage,
  EmailDisplay,
  ButtonGroup,
  VerificationButtonWrapper,
} from "./Auth.styles";

import Button from "../../components/Button/Button";
import SmallClouds from "../../components/utils/SmallClouds";
import { logout } from "../../store/slices/auth/asyncThunk";

export default function EmailVerificationNotice() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [isResending, setIsResending] = useState(false);

  const handleResendEmail = async () => {
    if (!user?.email) {
      toast.error("Nema email adrese");
      return;
    }

    setIsResending(true);
    try {
      const response = await axiosAdminAuthClient.post("/resend-verification", {
        email: user.email,
      });

      if (response.data.success) {
        toast.success(
          "Verifikacioni email je uspešno poslat! Proverite vaš inbox."
        );
      }
    } catch (error) {
      console.error("Resend email error:", error);

      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Greška pri slanju verifikacionog email-a");
      }
    } finally {
      setIsResending(false);
    }
  };

  return (
    <AuthPageWrapper>
      <AuthBackground />
      <SmallClouds />

      <AuthWrapper>
        <AuthContainer>
          <AuthTitle>Verifikacija Email-a</AuthTitle>
          <AuthSubtitle>Potrebno je da verifikujete vaš email</AuthSubtitle>

          <AuthForm>
            <StatusContainer>
              <StatusIcon $status="error">
                <FaExclamationTriangle />
              </StatusIcon>

              <StatusTitle>Email nije verifikovan</StatusTitle>

              <StatusMessage>
                Da biste pristupili ovoj funkcionalnosti, potrebno je prvo da
                verifikujete vaš email. Proverite vaš inbox za verifikacioni
                link ili kliknite dugme ispod da pošaljemo novi.
              </StatusMessage>

              <EmailDisplay>
                Email: <strong>{user?.email}</strong>
              </EmailDisplay>

              <VerificationButtonWrapper>
                <Button
                  onClick={handleResendEmail}
                  disabled={isResending}
                  loading={isResending}
                  title={"Pošalji novi link"}
                  lightColor={"var(--plava)"}
                  darkColor={"var(--bg-plava)"}
                  leftIcon={<FaEnvelope />}
                />
              </VerificationButtonWrapper>

              <ButtonGroup>
                <AuthLink
                  onClick={() =>
                    dispatch(logout()).then(() => {
                      navigate("/");
                    })
                  }
                >
                  Odjavi se
                </AuthLink>
                <AuthLink onClick={() => navigate("/")}>
                  Početna strana
                </AuthLink>
              </ButtonGroup>
            </StatusContainer>
          </AuthForm>
        </AuthContainer>
      </AuthWrapper>
    </AuthPageWrapper>
  );
}
